import { REQUEST_TIMEOUT } from '@/config/settings'
import { SiteContextModeEnum } from '@/enums/SiteContextModeEnum'
import { env } from '@/lib/env'

import type { ClientConfig } from '@sanity/client'

export const sanityConfig = {
  dataset: env.SANITY_DATASET,
  projectId: env.SANITY_PROJECT_ID,
  useCdn: env.NODE_ENV === 'production',
  // see https://www.sanity.io/docs/api-versioning for how versioning works
  apiVersion: 'v1',
  maxRetries: 2,
  timeout: REQUEST_TIMEOUT,
} satisfies ClientConfig

export const isDevelop = env.NODE_ENV === 'development'

export const defaultSiteContextMode = SiteContextModeEnum.b2b
